<ng-container *ngIf="!isModalComponent">
  <ng-container *ngTemplateOutlet="body; context: { $implicit: loading }"></ng-container>
</ng-container>

<ng-container *ngIf="isModalComponent">
  <ng-container *ngTemplateOutlet="modal; context: { $implicit: body, loading: loading }"></ng-container>
</ng-container>

<ng-template #body let-loading="loading">
  <div class="product-filter">
    <form [formGroup]="filterForm" *ngIf="filterForm && !loading; else loadingBlock">
      <div class="product-filter__group">
        <h5>{{ "product.filter.label.categories" | translate }}</h5>

        <ng-container *ngFor="let category of categories; let i = index" [formArrayName]="productFilterName.categories">
          <div class="form-input">
            <input
              type="checkbox"
              name="{{ category.name }}"
              [id]="isModalComponent ? 'filter-modal-category-' + i : 'filter-category-' + i"
              [formControlName]="i"
            />
            <label [for]="isModalComponent ? 'filter-modal-category-' + i : 'filter-category-' + i">
              {{ category.title }}
            </label>
          </div>
        </ng-container>
      </div>

      <div class="product-filter__group">
        <h5>{{ "product.filter.label.subcategories" | translate }}</h5>

        <ng-container *ngIf="hasSelectedCategories">
          <ng-container *ngFor="let subcategory of subcategories; let i = index" [formArrayName]="productFilterName.subcategories">
            <div class="form-input" [hidden]="isSubcategoryHidden(subcategory.title)">
              <input
                type="checkbox"
                name="{{ subcategory.title }}"
                [id]="isModalComponent ? 'filter-modal-subcategory-' + i : 'filter-subcategory-' + i"
                [formControlName]="i"
              />
              <label [for]="isModalComponent ? 'filter-modal-subcategory-' + i : 'filter-subcategory-' + i">
                {{ subcategory.title }}
              </label>
            </div>
          </ng-container>
        </ng-container>
        <p *ngIf="!hasSelectedCategories">{{ "product.filter.label.select_category" | translate }}</p>
        <p *ngIf="hasSelectedCategories && !subcategoriesHasVisibleItems">
          {{ "product.filter.label.no_subcategories_found" | translate }}
        </p>
      </div>

      <div class="product-filter__group">
        <h5>{{ "product.filter.label.spotlighted" | translate }}</h5>

        <div class="form-input">
          <input
            type="checkbox"
            name="spotlighted"
            [id]="isModalComponent ? 'filter-modal-spotlighted' : 'filter-spotlighted'"
            [formControlName]="productFilterName.spotlighted"
          />
          <label [for]="isModalComponent ? 'filter-modal-spotlighted' : 'filter-spotlighted'">
            {{ "general.label.yes" | translate }}
          </label>
        </div>
      </div>

      <div class="product-filter__group">
        <h5>{{ "general.label.air_miles" | translate }}</h5>
        <air-slider
          *ngIf="rangeCeiling"
          [floor]="0"
          [ceil]="rangeCeiling"
          [initSelectedValues]="initialFilters.range"
          (sliderUpdate)="onSliderUpdate($event)"
          [showInputThresholds]="!isModalComponent"
        ></air-slider>
        <div class="form-input">
          <input
            type="checkbox"
            name="miles-only"
            [id]="isModalComponent ? 'filter-modal-miles-only' : 'filter-miles-only'"
            [formControlName]="productFilterName.milesOnly"
          />
          <label [for]="isModalComponent ? 'filter-modal-miles-only' : 'filter-miles-only'">
            {{ "general.label.miles_only" | translate }}
          </label>
        </div>
      </div>

      <div *ngIf="partnersList" class="product-filter__group">
        <h5>{{ "product.filter.label.redemption_partners" | translate }}</h5>

        <div [hidden]="!partnerListHasVisibleItems">
          <ng-container *ngFor="let partner of partnersList; let i = index" formArrayName="partners">
            <div class="form-input" [hidden]="isPartnerHidden(partner)">
              <input
                type="checkbox"
                name="{{ partner.supplierCode }}"
                [id]="isModalComponent ? 'filter-modal-partner-' + i : 'filter-partner-' + i"
                [formControlName]="i"
              />
              <label [for]="isModalComponent ? 'filter-modal-partner-' + i : 'filter-partner-' + i">
                {{ partner.title }}
              </label>
            </div>
          </ng-container>
          <a *ngIf="isPartnerListExpandable" class="product-filter__btn--expand" (click)="toggleExpandPartnerList()">
            <i class="icon" [ngClass]="partnerListExpanded ? 'icon-ui-arrow--up' : 'icon-ui-arrow--down'"></i>
            <span>
              {{
                (partnerListExpanded ? "product.filter.label.less_redemption_partners" : "product.filter.label.more_redemption_partners")
                  | translate
              }}
            </span>
          </a>
        </div>
        <div *ngIf="!partnerListHasVisibleItems">
          <p>{{ "product.filter.label.no_partners_found" | translate }}</p>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #modal let-template>
  <header class="modal__header">
    <h3>{{ "product.filter.label.filter" | translate }}</h3>
    <a class="button button--transparent modal__button--close" (click)="close()"><i class="icon icon-ui-close--sm"></i></a>
  </header>
  <div class="modal__content">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
  <div class="modal__footer">
    <div class="button__group button__group--right">
      <a class="button button--secondary" (click)="close()">
        <span>{{ "general.label.cancel" | translate }}</span>
      </a>
      <a class="button button--primary" (click)="onApplyButtonClick()">
        <span>{{ "product.filter.label.apply_filters" | translate }}</span>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #loadingBlock>
  <div class="product-filter__group loading">
    <h5>{{ "general.label.loading" | translate }}</h5>

    <ng-container *ngFor="let skeleton of [] | range: 4">
      <div class="form-input">
        <input type="checkbox" />
        <label>{{ "general.label.loading" | translate }}</label>
      </div>
    </ng-container>
  </div>

  <div class="product-filter__group loading">
    <h5>{{ "general.label.loading" | translate }}</h5>
    <air-slider></air-slider>
    <div class="form-input">
      <input type="checkbox" />
      <label>{{ "general.label.loading" | translate }}</label>
    </div>
  </div>

  <div class="product-filter__group loading">
    <h5>{{ "general.label.loading" | translate }}</h5>

    <ng-container *ngFor="let skeleton of [] | range: 5">
      <div class="form-input">
        <input type="checkbox" />
        <label>{{ "general.label.loading" | translate }}</label>
      </div>
    </ng-container>
  </div>
</ng-template>
